export default __webpack_public_path__ + "static/media/user.73886533.svg";